module.exports = __webpack_public_path__ + "static/media/de03.a6c00014.jpg";